<template>
  <!--  <b-row :align-h="rowsOptions.alginH" :style="rowsStyle" @click.stop.prevent>-->
  <div class="row justify-content-center" :align-h="rowsOptions.alginH" :style="rowsStyle" @click.stop.prevent>
    <cx-big-screen-col
        v-for="(item, index) in rowsOptions.cols"
        :options="options"
        :zoom="zoom"
        :key="index"
        :colsOptions="item"
        :myid="myid"
    />
    <!--  </b-row>-->
  </div>
</template>

<script>
export default {
  name: "cx-row",
  props: {
    rowsOptions: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    },
    getParentH: {
      type: [Number, String]
    },
    getParentW: {
      type: [Number, String]
    }
  },
  computed: {
    rowsStyle() {
      let _style = {
        height: this.rowsOptions.height,
        margin: " 0 !important",
        width: "100%",
        "flex-wrap": "nowrap"
      }
      if (this.rowsOptions.margin) {
        Object.keys(this.rowsOptions.margin).forEach(marginKey => {
          _style[`margin${marginKey}`] = this.rowsOptions.margin[marginKey]
        })
      }
      return _style
    }
  }
}
</script>

<style scoped>
::v-deep .row {
  margin: 0 !important;
  flex-wrap: nowrap !important;
  justify-content: space-around;
}

/* body{
    justify-content: ;
} */
</style>
